// extracted by mini-css-extract-plugin
var _1 = "DeliveryUpdateListItem_delivered__1AmVO";
var _2 = "DeliveryUpdateListItem_error__GlTBe";
var _3 = "DeliveryUpdateListItem_inTransit__FpsgL";
var _4 = "DeliveryUpdateListItem_outForDelivery__SGesr";
var _5 = "DeliveryUpdateListItem_packageShipped__KABm+";
var _6 = "DeliveryUpdateListItem_processingShipment__JZcxG";
var _7 = "DeliveryUpdateListItem_statusDescription__-edwr";
var _8 = "DeliveryUpdateListItem_statusIcon__8fmHH";
var _9 = "DeliveryUpdateListItem_statusIconContainer__QoQnt";
var _a = "DeliveryUpdateListItem_statusText__rbXFi";
export { _1 as "delivered", _2 as "error", _3 as "inTransit", _4 as "outForDelivery", _5 as "packageShipped", _6 as "processingShipment", _7 as "statusDescription", _8 as "statusIcon", _9 as "statusIconContainer", _a as "statusText" }
